import axios from 'axios'
import store from '@/store'
import router from '@/router'

const logError = (url, data, error, transactionId) => {
  return store.dispatch('logs/logError', {
    stackTrace: `${axios.defaults.baseURL}${url}`,
    innerException: error.message,
    message:
      data.message ||
      data.ExceptionMessage ||
      data.Message ||
      error.message ||
      'Error',
    transactionId,
  })
}

const handleError = (transactionId) => {
  const routeData = {
    name: 'error',
  }
  if (transactionId) {
    routeData.query = { transactionId }
  }

  return router.push(routeData).catch((e) => {
    console.info(e)
  })
}

const axiosSetupInterceptors = () => {
  axios.defaults.baseURL = process.env.VUE_APP_API_URL

  axios.interceptors.request.use(
    async (config) => {
      config.headers['Content-Type'] = 'application/json'
      config.headers['Accept'] = 'application/json'
      config.headers['System'] = 'Paysid'

      return config
    },
    async (err) => {
      throw err
    }
  )
}

class AxiosWrapper {
  constructor() {
    axiosSetupInterceptors()
    this.axios = axios
  }

  async errorHandler(url, err, axiosConfig, customConfig = {}) {
    if (axios.isCancel(err)) {
      return []
    }

    const { retries } = customConfig
    const { config } = err
    const { skipError, transactionId } = customConfig || {}
    const data = (err && err.response && err.response.data) || {}

    if (retries) {
      customConfig.retries = retries - 1
      return this[config.method](url, config.data, axiosConfig, customConfig)
    }

    if (!skipError) {
      await logError(url, data, err, transactionId)
      await handleError(transactionId)
    }

    throw err
  }

  async post(url, data, axiosConfig, customConfig) {
    try {
      return await this.axios.post(url, data, axiosConfig)
    } catch (err) {
      return this.errorHandler(url, err, axiosConfig, customConfig)
    }
  }

  async get(url, params, axiosConfig, customConfig) {
    try {
      return await this.axios.get(url, params)
    } catch (err) {
      return this.errorHandler(url, err, axiosConfig, customConfig)
    }
  }

  async patch(url, data, axiosConfig, customConfig) {
    try {
      return await this.axios.patch(url, data, axiosConfig)
    } catch (err) {
      return this.errorHandler(url, err, axiosConfig, customConfig)
    }
  }

  async put(url, data, axiosConfig, customConfig) {
    try {
      return await this.axios.put(url, data, axiosConfig)
    } catch (err) {
      return this.errorHandler(url, err, axiosConfig, customConfig)
    }
  }

  async delete(url, data, axiosConfig, customConfig) {
    try {
      return await this.axios.delete(url, axiosConfig)
    } catch (err) {
      return this.errorHandler(url, err, axiosConfig, customConfig)
    }
  }
}

const wrapper = new AxiosWrapper()

export default wrapper
